import React from "react";
import PageHeader from "../Common/PageHeader";
import BillingLinks from "./BillingLinks";
import BillingIcon from "../../assets/icons/icon_reporting_financials_white-01.svg2";

export default function BillingLandingPage() {
  return (
    <div>
      <PageHeader
        Icon={BillingIcon}
        heading="Billing"
        subheading="Financial data for your account"
      >
        {" "}
      </PageHeader>

      <BillingLinks />
    </div>
  );
}
